import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';

/**
 * render img present in S3: brandclub/media_asset
 */
const AppImage = (_a) => {
    var { src, isRawSrc = false, alt } = _a, rest = __rest(_a, ["src", "isRawSrc", "alt"]);
    return React__default.createElement("img", Object.assign({ src: isRawSrc ? src : src, alt: alt }, rest));
};

export { AppImage };
//# sourceMappingURL=index.js.map
